import PropTypes from "prop-types";
import React, { Fragment } from "react";
import './header.less';
import { Link } from "gatsby";
// import Logo from "../images/logo.svg";
// import Cursor from "../images/cursor.gif";
// import Container from 'react-bootstrap/Container';
// import Navbar from 'react-bootstrap/Navbar';
// import Nav from 'react-bootstrap/Nav';
// import NavDropdown from 'react-bootstrap/NavDropdown';

const Header = ({ siteTitle }) => {
  let scrollHeight = 900;
  if (typeof window !== 'undefined') {
    scrollHeight =  window;
    console.log(scrollHeight);
    window.onscroll = () => {
      const nav = document.querySelector('#navbar');
      if(window.scrollY <= 600) {
        nav.className = 'header';
        document.getElementsByTagName('html')[0].classList.remove("on-scrollbar");
      } 
      else{ 
        nav.className = 'header scroll';
        document.getElementsByTagName('html')[0].classList.add("on-scrollbar");
      }
    };
  }
  else {
    console.log("Sorry Nav Not Working")
  }
  return (    
    <Fragment>
      <header id="navbar" className="header">
      <Link to="/"><span className={"logo"}><img src="data:image/png;base64,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" />&nbsp;&nbsp;</span></Link>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label className="menu-icon" htmlFor="menu-btn"><span className="navicon"></span></label>
        <ul className="menu">
          <li><Link to="../">Home</Link></li>          
          <li><Link to="../#projects">Projects</Link></li>
          <li><Link to="../#timeline">Timeline</Link></li>
          <li><Link to="/investment-portfolio">Investment Portfolio</Link></li>
          <li><a href="https://uspto.report/company/Sethi-Parminder-Singh" target="_blank">Patents</a></li>          
          <li><Link to="/gallery">Gallery</Link></li>
          <li><Link to="../#sayhello">Say Hello</Link></li>
        </ul>
      </header>
    </Fragment>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
